import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FooterPublic } from '../_UI/Footer/Public/FooterPublic';
import { ScrollToTopButton } from '../../../../Web/_UI/ScrollToTopButton';
import { HeaderPrivate } from '../_UI/Header/Private/HeaderPrivate';
import { userHasAccess } from '../../../HELPERS/_moduleFactory.helper';
import { SidebarPrivate } from '../_UI/Sidebar/Private/SidebarPrivate';
import { useSectionTitle } from '../../Hooks/Hooks/useSectionMetaTitle';
import { AppHeaderUtilities } from '../_UI/Header/_Utilities/AppHeaderUtilities';
import { BannerModeDevelopment } from '../../../_Config/UI/BannerModeDevelopment';
import { APP_SHELL_MENU, onResolveShellNav } from '../../../_Config/AppShell.Layout';
import { useLanguage } from '../../Hooks/Contexts/Translate/useLanguageContext';
import { buildPrivateSidebarNavigation } from '../../../../Web/Navigation/PrivateSidebar.navigation';

export const AppLayoutPrivate = ({ isAuth = true, user = null, onClickLogout = null, outletContext = {} }) => {

    const [useIsAsideOpen, setIsAsideOpen] = useState(false);

    const { pathname } = useLocation();

    const { useDataLanguage } = useLanguage();

    const SHELL_NAV = onResolveShellNav(user, useDataLanguage.currentLang);

    const BRAND = { ...APP_SHELL_MENU.brand, claim: SHELL_NAV.claim };

    const ACCESSIBLE_PRIVATE_ROUTES = SHELL_NAV.privateRoutes.filter((item) => userHasAccess(user, item));

    const SIDEBAR_NAV = buildPrivateSidebarNavigation({
        pathname,
        routes: ACCESSIBLE_PRIVATE_ROUTES,
    });

    useSectionTitle(SHELL_NAV.privateRoutes, APP_SHELL_MENU.brand.name);

    const onCloseAside = () => setIsAsideOpen(false);

    return (
        <div className="LStudio__app_shell LStudio__app_shell--private">
            <SidebarPrivate brand={BRAND} navItems={SIDEBAR_NAV}
                groupLabel={null} isOpen={useIsAsideOpen} onClose={onCloseAside} />

            <div className="LStudio__app_shell__column">

                <HeaderPrivate onToggleAside={() => setIsAsideOpen(true)} utilities={
                    <AppHeaderUtilities isAuth={isAuth} user={user}
                        onClickLogout={onClickLogout} profileLinks={SHELL_NAV.profileLinks}
                        languages={APP_SHELL_MENU.languages} data={{}} />} />

                <BannerModeDevelopment />

                <main className="LStudio__app_shell__main">
                    <div className="LStudio__app_shell__inner">
                        <Outlet context={outletContext} />
                    </div>

                    <ScrollToTopButton />

                </main>

                <FooterPublic isPrivate brand={BRAND} columns={SHELL_NAV.footerColumnsPrivate}
                    legal={SHELL_NAV.legal} showBrandLS={APP_SHELL_MENU.showBrandLS} />

            </div>
        </div>
    );
};
